module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mdl-grid adv-content",
    attrs: {
      "id": "page-adventure"
    }
  }, [(!_vm.user) ? _c('div', {
    staticClass: "mdl-cell mdl-grid mdl-cell--12-col",
    staticStyle: {
      "color": "white",
      "text-align": "left",
      "background-color": "rgba(255,255,255,0.1)",
      "padding": "5px"
    },
    attrs: {
      "id": "introductory-page"
    }
  }, [_c('div', {
    staticClass: "mdl-cell mdl-grid mdl-cell--8-col mdl-cell--12-col-tablet mdl-cell--12-col-phone"
  }, [_c('h4', {
    staticClass: "mdl-cell--12-col",
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v("Create, Play and Share your own Adventures")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col",
    staticStyle: {
      "display": "inline: block",
      "white-space": "nowrap",
      "text-overflow": "ellipsis",
      "overflow": "hidden"
    }
  }, [_c('router-link', {
    staticClass: "mdl-button mdl-button--raised",
    staticStyle: {
      "margin": "0 15px 0px 10px",
      "background-color": "white"
    },
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("SIGN IN")]), _vm._v("  to start creating and playing!\n      ")], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-grid mdl-cell--4-col mdl-cell--12-col-tablet mdl-cell--12-col-phone",
    staticStyle: {
      "background-color": "black"
    }
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "200",
      "src": "https://www.youtube.com/embed/OUH2FQaBcnM",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.hideTip) ? _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col",
    staticStyle: {
      "background-color": "rgba(255, 255, 255, 0.1)",
      "text-align": "right",
      "padding": "5px",
      "margin": "-10px 0px 8px 0px"
    }
  }, [_c('div', {
    staticClass: "mdl-button",
    staticStyle: {
      "font-size": "smaller",
      "margin-right": "3px",
      "opacity": "0.5"
    },
    on: {
      "click": _vm.hideTips
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("visibility_off")]), _vm._v(" hide this")]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-button mdl-button--raised",
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "to": "/editor"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")]), _vm._v(" Adventure Editor")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.itemsByDate), function(item) {
    return _c('div', {
      staticClass: "mdl-cell mdl-cell--stretch mdl-shadow--2dp mdl-cell--4-col mdl-cell--12-col-phone"
    }, [_c('div', {
      staticClass: "mdl-card",
      staticStyle: {
        "width": "100%"
      }
    }, [(item.cover) ? _c('div', {
      staticClass: "mdl-card__title",
      style: ('background-color: #777777; background-image: url(' + item.cover + '); padding: 28.125% 0 28.125% 0; background-repeat: no-repeat; background-size: contain;  background-position: center;')
    }) : _c('div', {
      staticClass: "mdl-card__title",
      staticStyle: {
        "display": "inline",
        "background-color": "#ccc",
        "color": "#999",
        "font-size": "24px",
        "font-weight": "bolder",
        "height": "0px",
        "width": "100%",
        "padding": "28.125% 0 28.125% 0",
        "text-align": "center"
      }
    }, [_vm._v("\n        NO COVER\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__title"
    }, [_c('h2', {
      staticClass: "mdl-card__title-text"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card_subtitle"
    }, [_vm._v("\n        By "), _c('router-link', {
      attrs: {
        "to": "/"
      }
    }, [_vm._v(_vm._s(item.owner.name))]), _vm._v(" - " + _vm._s(_vm._f("moment")(item.datePublished, "Do MMM YYYY")) + "    \n      ")], 1), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__supporting-text"
    }, [_vm._v("\n        " + _vm._s(item.description) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__actions mdl-card--border"
    }, [(_vm.user) ? _c('router-link', {
      staticClass: "mdl-cell--12-col-phone mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
      attrs: {
        "to": ('/play/' + item.key)
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("play_arrow")]), _vm._v(" " + _vm._s(_vm.getPlayText(item.key, _vm.savesInfo)) + "\n        ")]) : _c('router-link', {
      staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
      attrs: {
        "to": "login"
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("play_arrow")]), _vm._v(" Login to Play\n        ")]), _vm._v(" "), (_vm.user) ? _c('button', {
      staticClass: "mdl-cell--12-col-phone mdl-button mdl-js-button mdl-js-ripple-effect",
      on: {
        "click": function($event) {
          _vm.showDialog('shareAdventure', item.key)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("share")]), _vm._v("\n              Share\n          ")]) : _vm._e()], 1)])])
  }), _vm._v(" "), (!_vm.isShowingAll) ? _c('div', {
    staticClass: "adv-next-page-button"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--fab",
    on: {
      "click": _vm.showMore
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_more")])])]) : _c('div', {
    staticClass: "adv-next-page-button",
    staticStyle: {
      "font-style": "italic",
      "color": "white",
      "opacity": "0.3"
    }
  }, [_c('div', {
    staticStyle: {
      "border-top": "dashed 1px white",
      "opacity": "0.5",
      "width": "90%",
      "margin-left": "5%",
      "height": "5px",
      "margin-top": "15px"
    }
  }), _vm._v(" \n    Showing all adventures.\n  ")]), _vm._v(" "), _c('dialog', {
    staticClass: "mdl-dialog shareAdventure"
  }, [_c('div', {
    staticClass: "mdl-dialog__title"
  }, [_vm._v("Share this adventure")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-dialog__content"
  }, [_c('p', [_vm._v("\n        Share this URL with your friends:\n        "), _c('input', {
    staticClass: "mdl-textfield",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dialog_copy_text"
    },
    domProps: {
      "value": 'http://studio.adventify.com/#/play/' + _vm.selectedId
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--raised",
    staticStyle: {
      "position": "relative",
      "top": "5px"
    },
    attrs: {
      "onclick": "document.querySelector('#dialog_copy_text').select(); document.execCommand('copy'); document.querySelector('#dialog_copy_result').innerHTML = 'URL copied to clipboard!';"
    }
  }, [_vm._v("SELECT AND COPY")])]), _c('div', {
    staticStyle: {
      "position": "relative",
      "float": "left"
    },
    attrs: {
      "id": "dialog_copy_result"
    }
  }), _vm._v(" "), _c('p')]), _vm._v(" "), _vm._m(1)])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-grid",
    staticStyle: {
      "background-color": "rgba(255,255,255,0.1)",
      "text-align": "center",
      "border-radius": "5px",
      "padding-top": "5px",
      "padding-bottom": "5px"
    },
    attrs: {
      "id": "introductory-page-steps"
    }
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--3-col mdl-cell--12-col-tablet mdl-cell--12-col-phone"
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "position": "relative",
      "top": "5px"
    }
  }, [_vm._v("widgets")]), _vm._v(" Create Objects \n        ")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons mdl-cell mdl-cell--1-col mdl-cell--hide-tablet mdl-cell--hide-phone",
    staticStyle: {
      "position": "relative",
      "top": "5px"
    }
  }, [_vm._v("keyboard_arrow_right")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons mdl-cell mdl-cell--12-col mdl-cell--hide-desktop"
  }, [_vm._v("keyboard_arrow_down")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--3-col mdl-cell--12-col-tablet mdl-cell--12-col-phone"
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "position": "relative",
      "top": "5px"
    }
  }, [_vm._v("nature_people")]), _vm._v(" Compose Stages\n        ")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons mdl-cell mdl-cell--1-col mdl-cell--hide-tablet mdl-cell--hide-phone",
    staticStyle: {
      "position": "relative",
      "top": "5px"
    }
  }, [_vm._v("keyboard_arrow_right")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons mdl-cell mdl-cell--12-col mdl-cell--hide-desktop"
  }, [_vm._v("keyboard_arrow_down")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--3-col mdl-cell--12-col-tablet mdl-cell--12-col-phone"
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "position": "relative",
      "top": "5px"
    }
  }, [_vm._v("device_hub")]), _vm._v(" Build a Timeline\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-dialog__actions mdl-dialog__actions"
  }, [_c('button', {
    staticClass: "mdl-button close",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("CLOSE")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22742d26!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionAdventureFeed.vue
// module id = 303
// module chunks = 0